export default __webpack_public_path__ + "static/media/bg-fallback-en.f2873140.jpg";